export default "__VITE_ASSET__D4i6Oyi2__"